import * as React from 'react';
import { AboutModal } from 'app/shell/components/about-modal';
import { ChangePasswordModal } from 'app/area/user-profile/settings/change-password/change-password-modal';
import { FixedDocument } from 'app/components/fixed-document';
import { RefreshCacheModal } from 'app/shell/components/refresh-cache/refresh-cache-modal';
import { ExportToZipModal } from 'app/area/my-downloads/exports/export-to-zip-modal/export-to-zip-modal';
import { RegenerateAggregatedEnvModal } from 'app/shell/components/regenerate-aggregated/regenerate-aggregated-env';
import { RegenerateAggregatedRiskModal } from 'app/shell/components/regenerate-aggregated/regenerate-aggregated-risk';
import { RegenerateAggregatedTablesModal } from 'app/shell/components/regenerate-aggregated/regenerate-aggregated-tables';
import { MODAL } from 'app/shell/modal-host-types';
import { SelectedModal } from 'app/types-shared';

const ModalRegistry = {
  [MODAL.about]: AboutModal,
  [MODAL.changePassword]: ChangePasswordModal,
  [MODAL.refreshCache]: RefreshCacheModal,
  [MODAL.exportToZip]: ExportToZipModal,
  [MODAL.regenerateAggregatedEnv]: RegenerateAggregatedEnvModal,
  [MODAL.regenerateAggregatedRisk]: RegenerateAggregatedRiskModal,
  [MODAL.regenerateAggregatedTables]: RegenerateAggregatedTablesModal,
  [MODAL.none]: ''
};

export const modalFor = (modal: SelectedModal) => {
  return ModalRegistry[modal.name];
};

export interface ModalHostProps {
  selectedModal: SelectedModal;
  name: string;
  version?: string;
  onClose: () => void;
}

export const ModalHost = (props: ModalHostProps) => {
  const {
    selectedModal
  } = props;

  if (!selectedModal) {
    return null;
  }

  const Instance = modalFor(selectedModal) as any;

  return <FixedDocument>
      <Instance {...props}/>
    </FixedDocument>;
};
